const POINTER_KEY_PRIMARY: number = 0;

export default POINTER_KEY_PRIMARY;
